// local 1
// export const apiUrl = "http://localhost:5013";
// export const socketUrl = "http://localhost:5013";

// live (heroku)
export const apiUrl = "https://api.chemlance.com";
export const socketUrl = "https://api.chemlance.com";

// live 0
// export const apiUrl =
//   "https://z4sgbc3v-5013.inc1.devtunnels.ms";
// export const socketUrl = "https://z4sgbc3v-5013.inc1.devtunnels.ms";

export const s3Url = "https://chemlance-bucket.s3.eu-north-1.amazonaws.com";
export const flagUrl =
  "https://purecatamphetamine.github.io/country-flag-icons/3x2";
// live url 0
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
export const getFlagUrl = (isoCode) => {
  return `${flagUrl}/${isoCode}.svg`;
};
